import { QuantityData } from './types';

/**
 * Updates the quantity at the given index with the new quantity data.
 * If it is the new most likely won quantity, the other quantities will no longer be most likely won.
 */
export const setQuantityAtIndex = (
  previousQuantities: QuantityData[],
  index: number,
  quantity: QuantityData,
) => {
  return previousQuantities.map((q, i) => {
    if (i !== index && quantity.isMostLikelyWonQuantity) {
      return {
        ...q,
        isMostLikelyWonQuantity: false,
        mostLikelyWonQuantityPercent: null,
      };
    }

    if (i === index) {
      return quantity;
    }

    return q;
  });
};
